import { MixpanelGroup, MixpanelProperties, MixpanelType, People } from "mixpanel-react-native"

class Mixpanel {
  constructor(token: string, trackAutomaticEvents: boolean) {
    return this
  }

  public async init(optOutTrackingDefault?: boolean, superProperties?: MixpanelProperties, serverURL?: string) {
    return this;
  }

  public setServerURL(serverURL: string) {
    return undefined
  }

  public setLoggingEnabled(loggingEnabled: boolean) {
    return undefined
  }

  public setFlushOnBackground(flushOnBackground: boolean) {
    return undefined
  }

  public setUseIpAddressForGeolocation(useIpAddressForGeolocation: boolean) {
    return undefined
  }

  public async hasOptedOutTracking() {
    return true
  };

  public optInTracking() {
    return undefined;
  }

  public optOutTracking() {
    return undefined;
  }

  public identify(distinctId: string) {
    return undefined;
  }

  public alias(alias: string, distinctId: string) {
    return undefined;
  }

  public track(eventName: string, properties?: MixpanelProperties) {
    return undefined;
  }

  public getPeople(): People {
    return {
      set(value: any) { return undefined }
    } as People
  }

  public trackWithGroups(eventName: string, properties?: MixpanelProperties, groups?: MixpanelProperties) {
    return undefined;
  };

  public setGroup(groupKey: string, groupID: MixpanelType) {
    return undefined;
  };

  public getGroup(groupKey: string, groupID: MixpanelType): MixpanelGroup {
    return {} as MixpanelGroup
  }

  public addGroup(groupKey: string, groupID: MixpanelType) {
    return undefined;
  };

  public removeGroup(groupKey: string, groupID: MixpanelType) {
    return undefined;
  };

  public deleteGroup(groupKey: string, groupID: MixpanelType) {
    return undefined;
  };

  public registerSuperProperties(properties: MixpanelProperties) {
    return undefined;
  };

  public registerSuperPropertiesOnce(properties: MixpanelProperties) {
    return undefined;
  };

  public unregisterSuperProperty(propertyName: string) {
    return undefined;
  };

  public async getSuperProperties(): Promise<MixpanelProperties> {
    return {} as MixpanelProperties;
  }

  public clearSuperProperties() {
    return undefined;
  };

  public timeEvent(eventName: string) {
    return undefined;
  };

  public async eventElapsedTime(eventName: string) {
    return 0
  }

  public reset() {
    return undefined;
  };

  public async getDistinctId(): Promise<string> {
    return ''
  }

  public async getDeviceId(): Promise<string> {
    return ''
  }

  public flush() {
    return undefined;
  };

}

export {
  Mixpanel
}
